import { createAppLogger, AppLogger } from '@/utils/create-app-logger'

export function mfePreset(): void {
  /** Workaround for setting up OobeLogger on global typed */
  ;(globalThis as unknown as { OobeLogger: AppLogger }).OobeLogger =
    createAppLogger()
}
